export function removeConsecutiveDuplicates<T>(items: T[]): T[] {
  return items.filter((item, index, array) => {
    if (index === 0) return true;

    const currentStringified = JSON.stringify(item);
    const previousStringified = JSON.stringify(array[index - 1]);

    return currentStringified !== previousStringified;
  });
}
